"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeTextField = void 0;
const React = __importStar(require("react"));
const TextField_1 = __importDefault(require("@material-ui/core/TextField"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const BrowserDetect_1 = require("../helpers/BrowserDetect");
function DateTimeTextField({ label, variant, className, value, onChange, ...rest }) {
    const splitVal = value.split('T');
    const date = splitVal.length > 0 ? splitVal[0] : '';
    const time = splitVal.length > 1 ? splitVal[1] : '';
    const setDate = React.useCallback((d) => {
        onChange(`${d}T${time}`);
    }, [onChange, time]);
    const setTime = React.useCallback((t) => {
        onChange(`${date}T${t}`);
    }, [date, onChange]);
    const isSafariDesktop = BrowserDetect_1.useIsSafariDesktop();
    return !isSafariDesktop ? (React.createElement(TextField_1.default, Object.assign({ label: label, variant: variant, className: className !== null && className !== void 0 ? className : '' }, rest, { type: "datetime-local", value: value, onChange: (e) => {
            onChange(e.target.value);
        } }))) : (React.createElement(Box_1.default, { display: "flex", className: className },
        React.createElement(TextField_1.default, Object.assign({ label: 'Date', variant: variant, value: date, onChange: (e) => {
                setDate(e.target.value);
            } }, rest, { type: "date" })),
        React.createElement(Box_1.default, { p: 1 }),
        React.createElement(TextField_1.default, Object.assign({ label: "Time", variant: variant, value: time, onChange: (e) => {
                setTime(e.target.value);
            } }, rest, { type: "time" }))));
}
exports.DateTimeTextField = DateTimeTextField;
